import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 發送電子郵件驗證碼
 */
const SendMailOtp = [
    'POST',
    RouteUrlList.API_SendMailOtp.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        code: 0,
        letter: 'Mail',
        isInWaitToSendAgain: false,
        dayLimit: 10,
        times: 1
    }
];
export default SendMailOtp;
